import VendingDashboardPage from './VendingDashboardPage.js';
import TerminalsPage from './TerminalsPage.js';
import ProductsPage from './ProductsPage.js';
import TransactionsPage from './TransactionsPage.js';
import PaymentProvidersPage from './PaymentProvidersPage.js';

export async function registerVendingPages(app) {
    app.registerPage('group/vending/dashboard', VendingDashboardPage);
    app.registerPage('group/vending/machines', TerminalsPage);
    app.registerPage('group/vending/products', ProductsPage);
    app.registerPage('group/vending/transactions', TransactionsPage);
    app.registerPage('group/vending/payments', PaymentProvidersPage);

    // ── Vending platform sidebar ──────────────────────────────────────────────
    app.sidebar.addMenu('group_vending', {
        name: 'group_vending',
        groupKind: 'any',
        className: 'sidebar sidebar-dark',
        items: [
            {
                icon: 'bi-speedometer2',
                text: 'Dashboard',
                route: '?page=group/vending/dashboard',
                permissions: ['view_payments', 'manage_payments', 'payments', 'manage_group', 'manage_groups'],
            },
            {
                icon: 'bi-shop',
                text: 'Terminals',
                route: '?page=group/vending/machines',
                permissions: ['view_payments', 'manage_payments', 'payments', 'manage_group', 'manage_groups'],
            },
            {
                icon: 'bi-box-seam',
                text: 'Products & Inventory',
                route: '?page=group/vending/products',
                permissions: ['view_payments', 'manage_payments', 'payments', 'manage_group', 'manage_groups'],
            },
            {
                icon: 'bi-credit-card',
                text: 'Transactions',
                route: '?page=group/vending/transactions',
                permissions: ['view_payments', 'manage_payments', 'payments', 'manage_group', 'manage_groups'],
            },
            {
                icon: 'bi-bank',
                text: 'Payment Providers',
                route: '?page=group/vending/payments',
                permissions: ['manage_payments', 'payments', 'manage_group', 'manage_groups'],
            },
        ],
        footer: `
        <div class="text-center py-3">
        <img style='width:150px;' src='/imgs/camactive_logo_light.png' alt='Camactive Logo' class='footer-logo'>
        <div class="text-center">${app.version}</div>
        </div>
        `
    });
}
